// extracted by mini-css-extract-plugin
export default {"item":"Itext_item__U50sE","header":"Itext_header__IMBkK","body":"Itext_body__Jeeg0","button":"Itext_button__U5ryT","icon":"Itext_icon__fX9dO","iconPlus":"Itext_iconPlus__cTfhR"};